import { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";

import { personsSummaryQuery } from "../api";
import { personOption } from "./utils";
import { useQuery } from "@tanstack/react-query";

// filters out the ids in excludedIds[]
export function PersonSelectMulti({ disabled, selectedPersons, selectChange, excludedIds, noLabel, supervised }) {
  const { t } = useTranslation();

  const [options, setOptions] = useState([]);

  const res = useQuery(personsSummaryQuery(supervised ? "supervised" : "all"));

  useEffect(() => {
    if (res.data) {
      const results = res.data.data?.reduce((filtered, person) => {
        if ( !excludedIds.includes(person.personId) ) {
          filtered.push(personOption(person, t));
        }
        return filtered;
      }, []);

      setOptions(results);
    }
  }, [res.data]);


  return <Form.Group as={Col} controlId="participants">
    { !noLabel &&
    <Form.Label>{t("Participants", "Osallistujat")}</Form.Label>
    }
    <ReactSelect
      name="participants"
      inputId="participants"
      //menuPlacement="bottom"
      menuPosition="fixed"
      options={options}
      styles={{ menuPortal: provided => ({ ...provided, zIndex: 2 }) }} // zIndexFix
      placeholder={t("SelectPersons", "Valitse henkilöt")}
      noOptionsMessage={() => t("NoOptions", "Ei valintoja")}
      onChange={selectChange}
      value={selectedPersons?.map(person => options.find(option => option.value === person.personId) )}
      isDisabled={disabled}
      isMulti
    />
    <Form.Control.Feedback type="invalid">{t("PersonIsMandatory", "Henkilö on pakollinen")}.</Form.Control.Feedback>
  </Form.Group>;
}
